import React, { FormEvent, useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import './login.scss';
import { LoginAPI } from './login.api';
import { withRouter, Redirect } from 'react-router-dom';
import { LoginHelper } from '../helpers';

function Login(props) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginFailed, setLoginFailed] = useState(false);

    const loginAPI = new LoginAPI();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setLoginFailed(false);
        const userData = await loginAPI.loginUser(username, password);
        if (userData?.error) {
            setLoginFailed(true);
            return null;
        }
        LoginHelper.storeToken(userData.token);
        localStorage.setItem('operator', username);
        props.history.push('/');
    }

    if (props.authenticated) {
        return <Redirect to='/' />
    }

    return (
        <div className="login-wrapper">
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="username">
                    <Form.Label>Ім'я користувача</Form.Label>
                    <Form.Control
                        autoFocus
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </Form.Group>
                <Form.Group controlId="password">
                    <Form.Label>Пароль</Form.Label>
                    <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Form.Group>
                <Button size="lg" type="submit" className="submit" disabled={!LoginHelper.validateForm(username, password)}>
                    Увійти до системи
                </Button>
            </Form>
            {loginFailed && (<Alert variant="danger" className="login-failed-alert">
                Неправильний логін або пароль
            </Alert>)}
        </div>
    );
}

export default withRouter(Login);
